var amdi18n={"__root":{"settings":"Settings","factoryfixture_devicegroup_create":"Create Fixture Device Group","create":"Create","invalid_device_group_type":"Invalid Device Group Type","select":"Select","deployment_date":"Deployment Date","deployed_to":"Deployed To","deployed_by":"Deployed By","success_1":"Successfully updated ","success_2":" with Deployment","promoted_code":"Promoted Development Device Group Deployment","promoted_factory_code":"Promoted Development Group, Test Fixture and Fixture Deployments","promoted_test_factory_code":"Development Group, Test Fixture and Fixture Deployments","development_code":"Development Device Group Deployments","pre_production_code":"Development, Test Production and Production Device Group Deployments","production_code":"Promoted Development, Test Production and Production Device Group Deployments","dut_code":"Promoted Development, Test DUT and DUT Device Group Deployments","pre_dut_code":"Development, and Test DUT and DUT Device Group Deployments","type":"Type","number_devices":"Number of Devices","confirm_deploy":"Confirm and Deploy","deployment_comment":"Deployment Comment","saved_created_on":"Saved / Created On","sha":"sha","owner":"owner","creator":"author","go_live_title":"Go Live","go_live_target_production_group":"Select a Development Production Group","go_live_target_dut_group":"Select a DUT Device Group","go_live_target_factory_group":"Select a Pre-Factory Fixture Device Group"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;